import styles from './admin-licenses.module.scss';
import { booleanHeader, Box, Container, CreateHeaders, dateHeader, HeaderSizeEnum, textHeader } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { useState } from 'react';
import PageTitle from '../../page-title/page-title';
import AdminLicensesGridSkeleton from '../licenses-grid/licenses-grid-skeleton';
import { useGetRequestNewHook, useTableConfigHook } from '../../requestUtils';
import WebkuaTable from '../../webkua-table/webkua-table';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface LicensesProps { }
interface IAllLicense {
  licenseNumber: string;
  productName: string;
  isActive: boolean;
}

export function Licenses(props: LicensesProps) {
  const { t } = useTranslation();
  const tableConfig = useTableConfigHook("adminLicenses");
  const { data: licenses, isLoading }: { data: IAllLicense[], isLoading: boolean } = useGetRequestNewHook(`licenses/action/detailed`, []);
  const [onlyActive, setOnlyActive] = useState(true);


  const dateFilteredLicenses = licenses.filter(l => {
    if (onlyActive) {
      return l.isActive;
    }
    return true;

  });
  const handleOnlyActiveToggle = () => setOnlyActive(!onlyActive);
  const headers = CreateHeaders([
    textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("productName", t("standard.name"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("contractNumber", t("standard.contractNo"), HeaderSizeEnum.MEDIUM),
    textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("companyName", t("standard.customerName"), HeaderSizeEnum.EXTRA_LARGE),
    dateHeader("startDate", t("standard.startDate")),
    dateHeader("endDate", t("standard.terminationDate")),
    dateHeader("nextInvoiceDate", t("standard.nextInvoiceDate")),
    textHeader("discount", t("standard.discountPercent"), HeaderSizeEnum.MEDIUM, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    booleanHeader("isAcademic", t("standard.academicVersion")),
    textHeader("licenseType", t("standard.licenseType"), HeaderSizeEnum.MEDIUM),
  ]);


  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.licenses")} subtitle={`(${t("standard.admin")})`} />
            {!dateFilteredLicenses ?
              <AdminLicensesGridSkeleton /> :
              <WebkuaTable
                headers={headers}
                tableFilters={[
                  {
                    label: t('standard.activeOnly'),
                    checked: onlyActive,
                    onChange: handleOnlyActiveToggle
                  }
                ]}
                isLoading={isLoading}
                data={dateFilteredLicenses}
                tableConfig={tableConfig}
              />
            }
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default Licenses;